import { useMutation } from '@tanstack/react-query'

import { ScoredLoan } from '@ilg-totallymoney/types'

import { PageApiError } from '@api/utils/PageApiError'

import { handleApiResponse } from '@queries/utils/handleApiResponse'

interface PostSingleProviderScoreResponse {
    loanAmount: number
    loanTerm: number
    scores: ScoredLoan[]
}

export const useSingleProviderScoreMutation = () => {
    return useMutation<
        PostSingleProviderScoreResponse,
        PageApiError,
        {
            customerId?: string
            loanAmount?: number
            loanPurpose?: string
            loanTerm?: number
            loansScoreId?: string | null
            providerName: 'LittleLoans'
        }
    >({
        mutationKey: ['single-provider-score'],
        mutationFn: async ({
            loanAmount,
            loanTerm,
            loansScoreId,
            loanPurpose,
            customerId,
            providerName,
        }) => {
            const response = await fetch(
                `${process.env.NEXT_PUBLIC_BASE_PATH}/api/scored-single-provider/`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        loansScoreId,
                        loanAmount,
                        loanTerm,
                        loanPurpose,
                        customerId,
                        providerName,
                    }),
                }
            )
            return handleApiResponse(response)
        },
    })
}
